import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=05352e4c&scoped=true&"
import script from "./resume.vue?vue&type=script&lang=js&"
export * from "./resume.vue?vue&type=script&lang=js&"
import style0 from "./resume.vue?vue&type=style&index=0&id=05352e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05352e4c",
  null
  
)

export default component.exports